

import IFilter from '../ifilter';
import moment from 'moment';

export default class GetDateFormattedFilter implements IFilter {
    public filterName;

    constructor() {
        this.filterName = 'getDateFormatted';
    }

    public filterAction(dateTimeString: string, outFormat?: string, inFormat?: string) {
        outFormat = outFormat || 'DD/MM/YYYY';
        inFormat = inFormat || 'YYYY-MM-DD HH:mm:ss';

        return this.getDateFormatted(dateTimeString, outFormat, inFormat);
    }

    private getDateFormatted = (dateTimeString: string, outFormat: string, inFormat: string) => {
        const momentDate = moment(dateTimeString, inFormat);
        return momentDate.isValid() ? momentDate.format(outFormat) : '';
    }
}
